/*
 * File: locale.slice.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:50 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 12:52 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { createSlice } from '@reduxjs/toolkit';

// Utilities
import { setCookie } from '../../../utilities/cookies';

// Constants
import {
	COUNTRY_COOKIE,
	COUNTRY_COOKIE_EXPIRATION,
	DEFAULT_COUNTRY, DEFAULT_LOCALE, LOCALE_COOKIE, LOCALE_COOKIE_EXPIRATION
} from '../../../../constants/base.constants';


/**
 * Constants
 */

export const initialState = {
	status: 'idle',
	error: null,
	value: {
		localeId: DEFAULT_LOCALE,
		localeBaseId: DEFAULT_LOCALE.split('-')[0],
		localePath: '',
		countryId: DEFAULT_COUNTRY,
		geo: {},
		url: {}
	},
};


/**
 * Slices
 */

export const localeSlice = createSlice({
	name: 'locale',
	initialState,
	reducers: {
		updateLocale: (state, action) => {

			// Set state
			state.value = {
				localeId: action.payload.locale_id,
				localeBaseId: action.payload.locale_base_id,
				localePath: action.payload.locale_path,
				countryId: action.payload.country_id,
				geo: action.payload.geo,
				url: action.payload.url
			};
		},
		updateLocaleId: (state, action) => {

			// Set state
			state.value = {
				...state.value,
				localeId: action.payload.localeId,
				localeBaseId: action.payload.localeBaseId,
				localePath: action.payload.localePath
			};

			// Update cookie
			setCookie(LOCALE_COOKIE, action.payload.localeId, action.payload.partner, LOCALE_COOKIE_EXPIRATION);
		},
		updateCountryId: (state, action) => {

			// Set state
			state.value = {
				...state.value,
				countryId: action.payload.countryId
			};

			// Update cookie
			setCookie(COUNTRY_COOKIE, action.payload.countryId, action.payload.partner, COUNTRY_COOKIE_EXPIRATION);
		},
		clearLocale: (state) => {

			// Clear state
			state.value = { ...initialState.value };
		},
	},
	extraReducers: {},
});


/**
 * Exports
 */

export const {
	updateLocale, updateLocaleId, updateCountryId, clearLocale
} = localeSlice.actions;

export default localeSlice.reducer;
